import React, { useState } from 'react';
import {
  // TablePagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
  Typography,
  Checkbox,
  IconButton
} from '@mui/material';
import posterImg from '../../assets/images/poster.jpg';
import styles from './styles.module.scss';
// import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../../firebase/firebaseConfig';
import { ModeEdit } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { IS_DEMO } from '../../utils/config';
import { showToast } from '../../utils/toast';
function createData(poster, title, duration, category, status, banner) {
  return { poster, title, duration, category, status, banner };
}

const rows = [
  createData(posterImg, 'Relaxing rainfall', '13 m', 'Meditation', 'Paid', true),
  createData(posterImg, 'Relaxing rainfall', '13 m', 'Meditation', 'Paid', true),
  createData(posterImg, 'Relaxing rainfall', '13 m', 'Meditation', 'Paid', true)
];

export default function ContentsTable({ posts, onDelete, bannerId = '' }) {
  
  const [banner, setBanner] = useState(bannerId);

  const onBannerChange = async (id) => {
    const configRef = doc(db, 'settings', 'config');
    const previousId = banner;
    setBanner(id);
    updateDoc(configRef, { banner_id: id })
      .then(() => {
        toast.success('Successfully set banner');
      })
      .catch(() => {
        setBanner(previousId);
        toast.error('Failed to set banner');
      });
  };

  return (
    <Box className={styles.table} display="flex" flexDirection="column" width="100%">
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>No.</TableCell>
              <TableCell align="left">Poster</TableCell>
              <TableCell align="left">Title</TableCell>
              <TableCell align="left">Category</TableCell>
              <TableCell align="left">Visible</TableCell>
              <TableCell align="left">Paid</TableCell>
              <TableCell align="left">Banner</TableCell>
              <TableCell align="left">Edit</TableCell>
              <TableCell align="left">Action</TableCell>
              <TableCell align="left"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {posts.map((post, index) => (
              <MyTableRow
                bannerId={banner}
                onBannerChange={onBannerChange}
                post={post}
                index={index}
                onDelete={onDelete}
                key={post.id}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}

function MyTableRow({ post, index, onDelete, bannerId, onBannerChange }) {
  const [visible, setVisible] = useState(post.visible);
  const [paid, setPaid] = useState(post.paid);
  const navigate = useNavigate();
  return (
    <TableRow key={post.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
      <TableCell component="th" scope="row">
        {index + 1}
      </TableCell>
      <TableCell align="left">
        <Box display="flex" justifyContent="flex-start">
          <img
            style={{ objectFit: 'cover', height: '90px', width: '90px' }}
            src={post.media.bannerImage}
            alt="poster"
          />
        </Box>
      </TableCell>
      <TableCell sx={{ verticalAlign: 'top' }} align="left">
        <Typography>{post.title}</Typography>
      </TableCell>
      <TableCell sx={{ verticalAlign: 'top' }} align="left">
        <Typography>{post.category}</Typography>
      </TableCell>{' '}
      <TableCell align="left">
        <Checkbox
          checked={visible}
          onClick={(event) => {
            if (IS_DEMO) {
              event.preventDefault();
              return showToast({
                type: 'error',
                message: 'This is a demo version. You cannot edit content.'
              });
            }
            setVisible(event.target.checked);
            const sfDocRef = doc(db, 'posts', post.id);
            updateDoc(sfDocRef, { visible: event.target.checked });
          }}
        />
      </TableCell>
      <TableCell align="left">
        <Checkbox
          checked={paid}
          onClick={(event) => {
            if (IS_DEMO) {
              event.preventDefault();
              return showToast({
                type: 'error',
                message: 'This is a demo version. You cannot edit content.'
              });
            }
            setPaid(event.target.checked);
            const sfDocRef = doc(db, 'posts', post.id);
            updateDoc(sfDocRef, { paid: event.target.checked });
          }}
        />
      </TableCell>
      <TableCell align="left">
        <Checkbox
          checked={bannerId === post.id}
          onClick={(event) => {
            if (IS_DEMO) {
              event.preventDefault();
              return showToast({
                type: 'error',
                message: 'This is a demo version. You cannot edit content.'
              });
            }
            onBannerChange(post.id);
          }}
        />
      </TableCell>
      <TableCell align="left">
        <IconButton
          onClick={() => {
            navigate(`/content/${post.id}`);
          }}>
          <ModeEdit />
        </IconButton>
      </TableCell>
      <TableCell align="left">
        <IconButton
          onClick={() => {
            onDelete(post.id);
          }}>
          <DeleteIcon />
        </IconButton>
      </TableCell>
    </TableRow>
  );
}
